<template lang="html">
  <vue100vh style="position: fixed; width: -webkit-fill-available;">
    <v-card flat>
      <v-container fluid class="pl-0 pr-0 pt-0 pb-0">
        <v-toolbar style="background-color: white !important;">
          <v-btn icon @click="toPage(`/chat-web/menu/${tokenroom}/${typeroom}`)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('Task.allTask.myProject', { count: listproject.length }) }}</v-toolbar-title>
      </v-toolbar>
        <v-layout row wrap class="mt-2 ml-4 mr-4 layout-height" v-if="progress" justify-center align-center>
          <v-progress-circular size="80" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
        <v-layout row wrap align-center justify-center class="mt-2 ml-4 mr-4" v-else>
          <v-btn absolute dark fab bottom right color="primary" small @click="open_create_project()">
            <v-icon style="color: white !important;">fa-solid fa-plus</v-icon>
          </v-btn>
          <v-layout row wrap align-center justify-center class="bg-white">
            <v-flex xs12 sm12 md12 class="ml-1 mt-3" v-if="listproject.length != 0">
              <v-text-field v-model="search" solo :label="$t('Task.allTask.placeholderSearchProject')" clearable
                append-icon="fa-solid fa-magnifying-glass"></v-text-field>
            </v-flex>
          </v-layout>
          <v-card flat class="layout-height">
            <v-flex class="pa-2" xs12 sm12 md12 v-if="FilterListProject.length != 0">
              <v-card class="mb-1 mr-1 ml-1 mt-1 card-project" @click="topage_task(item._id, item.tokenroom)"
                v-for="(item, index) in FilterListProject" :key="index">
                <v-layout column>
                  <v-flex class="pa-2" xs12 md12 sm12 lg12 xl12 @click="topage_task(item._id, item.tokenroom)">
                    <v-row>
                      <div class="font-size-20 font-weight-bold text-overflow-project ml-3 mt-2">{{ item.project_name }}
                      </div>
                      <v-spacer></v-spacer>
                      <div class="color-grey mr-3 mt-3" style="font-size: 12px;">
                        {{ datetime(item.timestamp) }}
                      </div>
                    </v-row>
                    <v-row justify-end class="ml-2 mt-3 pr-2">
                      <v-col cols="6">
                        <div class="text-overflow-detail" style="font-size: 13px;">
                          {{ item.detail }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <v-row class="justify-end align-center">
                          <div v-for="(i, index) in item.state" :key="index">
                            <v-chip small label class="chipColorTodo mr-1"
                              v-if="i.name.includes('Todo') || i.name.includes('todo')">
                              {{ i.name }} {{ i.count_member }}
                            </v-chip>
                            <v-chip small label class="chipColorDoing mr-1"
                              v-else-if="i.name.includes('Doing') || i.name.includes('doing')">
                              {{ i.name }} {{ i.count_member }}
                            </v-chip>
                            <v-chip small label class="chipColorDone mr-1"
                              v-else-if="i.name.includes('Done') || i.name.includes('done')">
                              {{ i.name }} {{ i.count_member }}
                            </v-chip>
                            <v-chip small label class="chipColorEtc mr-1" v-else>
                              {{ i.name }} {{ i.count_member }}
                            </v-chip>
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-layout row wrap class="ml-3 mb-2">
                      <v-avatar size="35px">
                        <img :src="item.path_pic" v-if="item.path_pic" class="object-fit-img">
                        <img :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" v-else
                          class="border-img object-fit-img">
                      </v-avatar>
                      <div class="text-overflow-project mt-2 ml-2" style="font-size: 14px;">{{ item.room_name }}</div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md12 v-else>
              <v-layout column wrap justify-center align-center style="height: 400px;">
                <v-icon style="font-size: 60px !important;">fas fa-tasks</v-icon>
                <h4 class="mt-3">{{ $t('Task.allTask.noProjectList') }}</h4>
              </v-layout>
            </v-flex>
          </v-card>
        </v-layout>
      </v-container>
      <CreateProject :dialogCreateProject="dialogCreateProject" @closeCreateProject="closeCreateProject"
        :projectid="projectid" @createdproject="createdproject"></CreateProject>
    </v-card>
  </vue100vh>
</template>

<script>
import { Momenttime } from '@/services'
import CreateProject from '@/views/Web/Manage/task/created_project_dialog_mo'
import vue100vh from 'vue-100vh'
var _ = require('lodash')
export default {
  data: () => ({
    publicPath: process.env.VUE_APP_BASE_PATH,
    tabs: '',
    tokenuser: '',
    tokenroom: '',
    listproject_user: [],
    listproject_group: [],
    listproject: [],
    progress: false,
    search: '',
    search_group: '',
    projectid: '',
    dialogCreateProject: false,
    data_user: {},
    typeroom: '',
  }),
  components: {
    CreateProject,
    vue100vh
  },
  created() {
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
    this.tokenroom = this.$route.params.tokenroom
    this.typeroom = this.$route.params.type
    this.get_project_by_tokenroom()
  },
  computed: {
    FilterListProject() {
      if (this.search !== '' && this.search !== null) {
        return this.listproject.filter(post => {
          return post.project_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listproject
      }
    },
    FilterListProjectGroup() {
      if (this.search_group !== '' && this.search_group !== null) {
        return this.listproject_group.filter(post => {
          return post.project_name.toLowerCase().includes(this.search_group.toLowerCase())
        })
      } else {
        return this.listproject_group
      }
    }
  },
  methods: {
    closeCreateProject(value) {
      this.dialogCreateProject = value
    },
    createdproject(value) {
      this.get_project_by_id(value.project_id, value.event)
    },
    open_create_project() {
      this.dialogCreateProject = true
    },
    datetime(timestamp) {
      return (this.$i18n.locale == 'th') ? Momenttime.dayjsdatethai(timestamp) : Momenttime.momentdateen(timestamp)
    },
    toPage(path) {
      console.log("path", path);
      this.$router.push(path)
    },
    topage_task(projectid, tokenroom) {
      this.$router.push('/chat-web/task/' + projectid + '/' + tokenroom + `/${this.typeroom}`)
    },
    get_project_by_tokenroom() {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_tokenroom', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.tokenroom
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.listproject = response.data.data
          this.listproject = _.reverse(_.sortBy(this.listproject, function (dateObj) {
            return new Date(dateObj.timestamp)
          }))
          this.projectid = this.listproject._id
          // console.log(this.listproject)
          // this.listproject_group = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('G') })
          // this.listproject_user = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('R') })
        } else {
          this.progress = false
          this.listproject = []
        }
      }).catch(error => {
        this.progress = false
        console.log(error.message)
      })
    },
    get_project_by_id(projectid, events) {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_id', {
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.tokenroom,
        project_id: projectid
      }).then((responsed) => {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            this.listproject.unshift({
              'project_name': responsed.data.data.project_name,
              'timestamp': responsed.data.data.timestamp,
              'count_task': '0',
              '_id': responsed.data.data._id,
              'detail': responsed.data.data.detail,
              'tokenroom': responsed.data.data.tokenroom,
              'state': responsed.data.data.state,
              'path_pic': responsed.data.data.owner_info.path_pic
            })
            // this.listproject.unshift(responsed.data.data)
          }
        }
      }).catch(error => {
        console.log(error.message)
      })
    }
  }
}
</script>

<style lang="css" scoped>
.chipColor {
  color: #2562af !important;
  background-color: transparent !important;
  border: 1px #2562af solid !important;
}

.chipColorTodo {
  color: #667684 !important;
  background-color: transparent !important;
  border: 1px #667684 solid !important;
}

.chipColorDoing {
  color: #33bcd4 !important;
  background-color: transparent !important;
  border: 1px #33bcd4 solid !important;
}

.chipColorDone {
  color: #6bc94f !important;
  background-color: transparent !important;
  border: 1px #6bc94f solid !important;
}

.chipColorEtc {
  color: #bcc0c7 !important;
  background-color: transparent !important;
  border: 1px #bcc0c7 solid !important;
}

.card-project:hover .chipColor {
  color: white !important;
  background-color: #2562af !important;
}

.card-project:hover .text-overflow-project {
  color: #2562af !important;
}

.card-project:hover .color-grey {
  color: #103567c7 !important;
}

>>>.v-tabs__container--icons-and-text {
  height: 64px !important;
}

>>>.v-input__slot {
  /* width: 165px !important; */
  border-radius: 13px !important;
  box-shadow: none !important;
  background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
}

>>>.theme--dark.v-label {
  color: rgba(0, 0, 0, .54) !important;
}

>>>.theme--dark.v-icon {
  color: rgb(35, 43, 53) !important;
}

>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: rgba(0, 0, 0, .54) !important;
}

.btn-fab {
  width: 24px !important;
  height: 24px !important;
}

>>>.v-chip .v-chip__content {
  border-radius: 28px !important;
  cursor: default !important;
  height: 20px !important;
  justify-content: space-between !important;
  padding: 0 6px !important;
  white-space: nowrap !important;
  z-index: 1 !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.text-overflow-project {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 125px !important;
}

.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}

.border-img {
  border-color: #80808052 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.layout-height {
  height: calc(100vh - 170px) !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  width: 100% !important;
}

.width-100 {
  width: 100% !important;
}

.card-project {
  border-radius: 10px !important;
  background-color: white !important;
  border-style: solid !important;
  border-width: thin !important;
  /* height: 165px !important; */
  cursor: pointer !important;
}

.color-grey {
  font-size: 13px !important;
  color: #827d7d !important;
}
</style>
